export default "__VITE_ASSET__DfIBQ7rS__"